"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var PaymentQueue_1 = require("../models/Payments/PaymentQueue");
var __1 = require("..");
exports.PaymentQueueAPI = {
    getPaymentQueues: function (companyId, locationId) {
        return __1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues").then(function (response) {
            var paymentQueues = response.data.paymentQueues;
            return paymentQueues;
        });
    },
    getFilteredAndPaginatedPaymentQueues: function (companyId, searchFilters) {
        return __1.axios.get("/api/v1/company/" + companyId + "/paymentQueues", {
            params: __assign({}, searchFilters),
        }).then(function (response) {
            var paginatedPaymentQueues = response.data;
            return paginatedPaymentQueues;
        });
    },
    getPaymentQueueById: function (companyId, locationId, queueId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, paymentQueue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __1.axios.get("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues/" + queueId)];
                    case 1:
                        response = _a.sent();
                        paymentQueue = response.data.paymentQueue;
                        return [2 /*return*/, paymentQueue];
                }
            });
        });
    },
    assignDeviceToPaymentQueue: function (companyId, locationId, queueId) {
        return __1.axios.post("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues/" + queueId + "/assignDevice").then(function (response) {
            var paymentQueues = response.data.paymentQueues;
            return paymentQueues;
        });
    },
    createPaymentQueue: function (companyId, locationId, createObject) {
        var createPaymentQueue = new PaymentQueue_1.CreatePaymentQueue(createObject);
        return __1.axios.post("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues", createPaymentQueue).then(function (response) {
            var paymentQueue = response.data;
            return paymentQueue;
        });
    },
    updatePaymentQueue: function (companyId, locationId, queueId, updateObject) {
        var updatePaymentQueue = new PaymentQueue_1.CreatePaymentQueue(updateObject);
        return __1.axios.put("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues/" + queueId, updatePaymentQueue).then(function (response) {
            var paymentQueue = response.data;
            return paymentQueue;
        });
    },
    updatePaymentQueueStatus: function (companyId, locationId, queueId, status) {
        return __1.axios.put("/api/v1/company/" + companyId + "/paymentQueues/" + queueId, { locationId: locationId, status: status }).then(function (response) {
            var paymentQueue = response.data;
            return paymentQueue;
        });
    },
    deletePaymentQueue: function (companyId, locationId, paymentQueueId) {
        return __1.axios.delete("/api/v1/company/" + companyId + "/location/" + locationId + "/paymentQueues/" + paymentQueueId);
    },
    deleteAllPaymentQueues: function (companyId) {
        return __1.axios.delete("/api/v1/company/" + companyId + "/paymentQueues");
    },
};
//# sourceMappingURL=PaymentQueueAPI.js.map